export default (props) => {
    return [
        {
            name: "ativo",
            label: "Fornecedores Ativos",
            options: {
                filter: false,
                download: false,
                customBodyRender: props.renderAtivo,
            },
        },
        {
            name: "ID_PESSOA",
            label: "Código do Fornecedor",
            options: {
                filter: true,
                download: true,
            },
        },
        {
            name: "NM_PESSOA",
            label: "Nome do Fornecedor",
            options: {
                filter: true,
                download: true,
            },
        },
        {
            name: "DS_EMAIL",
            label: "Email do Fornecedor",
            options: {
                filter: true,
                download: true,
            },
        },
        {
            name: "NM_COND_PAGTO",
            label: "Condição do pagamento",
            options: {
                filter: true,
                download: true,
            },
        },
        {
            name: "NR_DIAS_PRAZO",
            label: "Prazo",
            options: {
                filter: true,
                download: true,
            },
        },
    ];
};
